/** The per-area string files, spread into `ca` (src/i18n/ca.ts) so every key stays on one object. */
import { ca_campaign } from './ca-campaign';
import { ca_design } from './ca-design';
import { ca_direction } from './ca-direction';
import { ca_mission } from './ca-mission';
import { ca_servers } from './ca-servers';
import { ca_session } from './ca-session';
import { caShell } from './ca-shell';
import { ca_reports } from './ca-reports';
import { ca_admin } from './ca-admin';
import { ca_profile } from './ca-profile';
import { ca_catalog } from './ca-catalog';
import { ca_changelog } from './ca-changelog';
import { ca_roadmap } from './ca-roadmap';
import { ca_status } from './ca-status';
import { ca_tests } from './ca-tests';
import { ca_inspection } from './ca-inspection';
import { ca_script } from './ca-script';
import { ca_offline } from './ca-offline';

export const caAreas = {
  ...caShell,
  ...ca_session,
  ...ca_design,
  ...ca_direction,
  ...ca_mission,
  ...ca_campaign,
  ...ca_servers,
  ...ca_reports,
  ...ca_admin,
  ...ca_profile,
  ...ca_catalog,
  ...ca_changelog,
  ...ca_roadmap,
  ...ca_status,
  ...ca_tests,
  ...ca_inspection,
  ...ca_script,
  ...ca_offline,
};
